<template>
  <div class="series-view-wrap">
    <div
      v-if="list.length === 0"
      class="image-slot">
      <i
        class="el-icon-picture-outline"
        style="font-size:40px;"></i>
    </div>
    <template v-else>
      <el-row
        :gutter="12"
        style="width: 100%;">
        <el-col
          v-for="item in list"
          :key="item.id"
          :span="12">
          <div class="service-card">
            <div class="service-image-wrap">
              <img
                :src="item.image"
                class="service-image">
            </div>
            <div class="title">{{ item.servName }}</div>
            <div class="sub-title">{{ item.introduction }}</div>
          </div>
        </el-col>
      </el-row>
    </template>
  </div>
</template>
<script>
export default {
  name: 'WeSeriesView',
  props: {
    list: { type: Array, default() { return [] } }
  }
}
</script>
<style lang="stylus" scoped>
  .image-slot {
    width 100%
    height: 100px
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    color: #909399;
  }
.series-view-wrap {
  min-height: 100px
  padding: 0 8px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto
}
.service-card {
  margin-bottom: 8px;
}
.service-image-wrap {
  position relative
  padding-top: 60%;
}
.service-image {
    position absolute
    left: 0;
    top: 0
    width: 100%
    height: 100%
    object-fit: cover;
}
.title,.sub-title {
  text-overflow: ellipsis
  white-space: nowrap
  overflow hidden
}
.title {
  font-size: 14px;
  color: #47506d;
  line-height: 20px;
}
.sub-title {
  font-size: 12px;
  color: #8791b2;
  line-height: 18px;
  padding-top: 4px;
}
</style>
